export const state = {
	lang: localStorage.getItem('lang') || process.env.VUE_APP_I18N_LOCALE || 'en',
};
export const getters = {
	lang: state => state.lang,
};
export const mutations = {
	setLang(state, language) {
		state.lang = language;
		localStorage.setItem('lang', language); // Whenever we change the appLanguage we save it to the localStorage
	},
};
